// extracted by mini-css-extract-plugin
export default {"results-table":"ResultsList_results-table__YXoRz"};